/* ==========================================================================
   TJÅKKO product page behaviour.

   One file, no dependencies, loaded by `snippets/tj-pdp-assets.liquid`. Every
   block below is optional: a template with no size grid, no finder or no
   meter simply skips that part.

   Shrine re renders the buy column on every variant change, so nothing here
   binds to a node and keeps it. Everything re queries and re applies.

   It never touches the header, the cart drawer or the footer.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__tjPdpInit) return;
  window.__tjPdpInit = true;

  var CFG = window.TJ_PDP || (window.TJ_PDP = {});
  /* The size rule and size matching live in assets/tj-size-rule.js, shared
     with the "Hitta din storlek" wizard, so both give the same size.
     snippets/tj-pdp-assets.liquid loads it right before this file. */
  var RULE = window.TJSizeRule;
  var LABELS = CFG.labels || {};
  var NBSP = ' ';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var state = {
    sizeChosen: false,
    size: null,
    finderUsed: false,
    shippingReached: false,
    lastTrusted: -1000000,
    reapplies: 0
  };

  /* A shopper's own click is trusted. A picker app that preselects the first
     value for us clicks the radio itself, which is not, and that click arrives
     before the shopper has touched anything. Anything within 1.5s of a real
     pointer or key event still counts, because an app that renders its own
     swatches forwards the tap to the hidden radio the same way. */
  var TRUSTED_WINDOW = 1500;

  function markTrusted(e) {
    if (e && e.isTrusted) state.lastTrusted = Date.now();
  }

  ['pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (type) {
    document.addEventListener(type, markTrusted, true);
  });

  function shopperDriven(e) {
    if (e && e.isTrusted) return true;
    return Date.now() - state.lastTrusted < TRUSTED_WINDOW;
  }

  /* ---------- helpers ---------------------------------------------------- */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }


  function intAttr(el, name, fallback) {
    if (!el) return fallback;
    var v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }

  function floatAttr(el, name, fallback) {
    if (!el) return fallback;
    var v = parseFloat(String(el.getAttribute(name) || '').replace(',', '.'));
    return isNaN(v) ? fallback : v;
  }

  function cm(value) {
    return value.toFixed(1).replace('.', ',');
  }

  function fill(template, values) {
    var out = String(template || '');
    Object.keys(values).forEach(function (key) {
      out = out.split('{' + key + '}').join(values[key]);
    });
    return out;
  }

  /* ---------- money ------------------------------------------------------- */
  /* A port of Shopify's formatMoney. Input is öre, output follows
     TJ_PDP.moneyFormat, so the page never prints a total in one format and a
     price in another. The space separator is a non breaking space, so
     "1 699 kr" cannot break across two lines. */

  function digits(cents, decimals, thousands, decimal) {
    var amount = (Number(cents) / 100).toFixed(decimals);
    var parts = amount.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    if (decimals > 0 && parts[1]) return whole + decimal + parts[1];
    return whole;
  }

  function money(cents, format) {
    var fmt = format || CFG.moneyFormat || '{{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = match ? match[1] : 'amount';
    var value;

    switch (name) {
      case 'amount_no_decimals':
        value = digits(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = digits(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = digits(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = digits(cents, 2, NBSP, ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = digits(cents, 0, NBSP, ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = digits(cents, 2, NBSP, '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = digits(cents, 2, "'", '.');
        break;
      default:
        value = digits(cents, 2, ',', '.');
    }

    return match ? fmt.replace(match[0], value) : value;
  }

  /* the meter's server rendered first frame uses money_without_trailing_zeros,
     so the recompute has to drop a ",00" too or the number would change shape
     the moment the shopper touches anything */
  function moneyTrim(cents, format) {
    return money(cents, format).replace(/([.,])00(?!\d)/, '');
  }

  /* öre from a rendered price string such as "1 699 kr" or "209,00 kr" */
  function moneyToCents(text) {
    var raw = String(text || '').replace(/[^0-9.,]/g, '');
    if (!raw) return NaN;
    var decimals = raw.match(/[.,](\d{2})$/);
    var whole = decimals ? raw.slice(0, -3) : raw;
    whole = whole.replace(/[^0-9]/g, '');
    if (!whole) return NaN;
    return parseInt(whole, 10) * 100 + (decimals ? parseInt(decimals[1], 10) : 0);
  }

  /* ---------- tracking ----------------------------------------------------- */

  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: event, tj_template: CFG.templateSuffix || '' };
    if (payload) {
      Object.keys(payload).forEach(function (key) {
        data[key] = payload[key];
      });
    }
    window.dataLayer.push(data);
  }

  /* ---------- Shrine pub/sub ---------------------------------------------- */
  /* The constants live in the remote runtime's own lexical scope, so
     `window.PUB_SUB_EVENTS` can be undefined even when the runtime is loaded.
     Read the bare identifier behind a typeof guard and fall back to the
     literal event names. A `change` listener on the pickers runs in every
     case, so a missing pub/sub never disables the gate. */

  function eventName(key, fallback) {
    try {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS[key]) {
        return PUB_SUB_EVENTS[key];
      }
    } catch (e) {
      /* not defined in this scope */
    }
    if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS[key]) return window.PUB_SUB_EVENTS[key];
    return fallback;
  }

  function subscribeTo(key, fallback, handler) {
    if (typeof window.subscribe !== 'function') return;
    try {
      window.subscribe(eventName(key, fallback), handler);
    } catch (e) {
      /* the runtime changed shape; the DOM listeners still cover us */
    }
  }

  /* ---------- the buy column ---------------------------------------------- */

  function mainForm() {
    return $('product-form.main-product-form form[data-type="add-to-cart-form"]') ||
      $('form[data-type="add-to-cart-form"]');
  }

  function mainAtc() {
    return $('.product-form__submit.main-product-atc') || $('.product-form__submit');
  }

  function stickyAtc() {
    return $('.sticky-atc__add_button');
  }

  function variantIdInput() {
    var form = mainForm();
    return form ? form.querySelector('input[name="id"]') : $('input.product-variant-id');
  }

  /* The size group is found by option name, never by position. A one option
     product puts Storlek first, a two option product puts it second, and the
     merchant's picker settings decide whether it renders as pills or as
     swatches, so neither the index nor the `--pills` class can be trusted.
     Shrine names every radio after the option (`name="Storlek"`), the noscript
     select names it `options[Storlek]`, and the label text is the third read. */

  /* "20/21", "20-21", "20 21" and "20–21" are one size: KEEN names the size
     "20/21" in its table and "20-21" on the variant. Every size comparison in
     this file goes through here. */
  function sameSize(a, b) {
    if (RULE) return RULE.sameSize(a, b);
    return String(a == null ? '' : a).trim() === String(b == null ? '' : b).trim();
  }

  function isSizeName(raw) {
    var name = String(raw || '')
      .replace(/^options\[/, '')
      .replace(/\]$/, '')
      .toLowerCase();
    if (!name) return false;
    return name.indexOf('storlek') !== -1 || /\bsizes?\b/.test(name);
  }

  function groupOptionName(group) {
    var radio = group.querySelector('input[type="radio"][name]');
    if (radio) return radio.getAttribute('name');
    var select = group.querySelector('select[name]');
    if (select) return select.getAttribute('name');
    var label = group.querySelector('.form__label-text, legend, label');
    return label ? label.textContent : '';
  }

  /* a lone group of plain shoe numbers is a size group even when the merchant
     named the option something the list above does not know */
  function looksLikeSizes(group) {
    var radios = $$('input[type="radio"]', group);
    if (radios.length < 3) return false;
    for (var i = 0; i < radios.length; i++) {
      if (!/^\d{1,2}([.,]\d)?$/.test(String(radios[i].value).trim())) return false;
    }
    return true;
  }

  function sizeGroup() {
    var groups = $$('variant-selects .product-form__input');
    if (!groups.length) return null;

    var withRadios = groups.filter(function (group) {
      return !!group.querySelector('input[type="radio"]');
    });
    if (!withRadios.length) return null;

    for (var i = 0; i < withRadios.length; i++) {
      if (isSizeName(groupOptionName(withRadios[i]))) return withRadios[i];
    }
    if (withRadios.length === 1 && looksLikeSizes(withRadios[0])) return withRadios[0];
    return null;
  }

  /* ---------- the picker the shopper actually sees ------------------------- */
  /* A swatch app can hide Shrine's picker and render its own markup, driving
     the hidden radios underneath. The radios stay the source of truth for the
     form; these helpers keep the app's own selected state honest. */

  function appSizeGroups() {
    return $$('variant-swatch-king [option-name]').filter(function (node) {
      return isSizeName(node.getAttribute('option-name'));
    });
  }

  function appCellForSize(size) {
    var wanted = String(size).trim();
    var found = null;
    appSizeGroups().forEach(function (root) {
      if (found) return;
      $$('[data-value]', root).forEach(function (node) {
        if (!found && sameSize(node.getAttribute('data-value'), wanted)) found = node;
      });
    });
    return found;
  }

  function clearAppSelection() {
    appSizeGroups().forEach(function (root) {
      $$('.swatch-selected', root).forEach(function (node) {
        node.classList.remove('swatch-selected');
      });
      $$('[role="radio"][aria-checked="true"]', root).forEach(function (node) {
        node.setAttribute('aria-checked', 'false');
      });
    });
  }

  /* Shrine prints `checked` in the markup and apps add their own flags. The
     property alone is not enough: a form reset or a re render reads the
     attribute back. */
  function clearShrineSelection(group) {
    sizeRadios(group).forEach(function (radio) {
      radio.checked = false;
      if (radio.hasAttribute('checked')) radio.removeAttribute('checked');
      if (radio.getAttribute('aria-checked') === 'true') radio.setAttribute('aria-checked', 'false');
      if (radio.getAttribute('data-selected') === 'true') radio.setAttribute('data-selected', 'false');
      radio.classList.remove('selected', 'is-selected', 'active');

      var label = radio.id ? group.querySelector('label[for="' + radio.id + '"]') : null;
      if (!label && radio.nextElementSibling && radio.nextElementSibling.tagName === 'LABEL') {
        label = radio.nextElementSibling;
      }
      if (label) {
        label.classList.remove('selected', 'is-selected', 'active');
        if (label.getAttribute('aria-checked') === 'true') label.setAttribute('aria-checked', 'false');
      }

      var cell = closest(radio, '.color-swatch, .swatch-view-item');
      if (cell) {
        cell.classList.remove('selected', 'is-selected', 'active');
        if (cell.getAttribute('aria-checked') === 'true') cell.setAttribute('aria-checked', 'false');
      }
    });
    clearAppSelection();
  }

  function sizeRadios(group) {
    return $$('input[type="radio"]', group || sizeGroup() || document.createElement('div'));
  }

  function radioForSize(size) {
    var group = sizeGroup();
    if (!group) return null;
    var radios = sizeRadios(group);
    for (var i = 0; i < radios.length; i++) {
      if (sameSize(radios[i].value, size)) return radios[i];
    }
    return null;
  }

  function isSoldOut(radio) {
    if (!radio) return true;
    return radio.classList.contains('disabled') ||
      radio.classList.contains('unavailable') ||
      radio.classList.contains('non-existent');
  }

  function sizeAvailable(size) {
    var group = sizeGroup();
    if (!group) return true;
    var radio = radioForSize(size);
    if (!radio) return false;
    return !isSoldOut(radio);
  }

  /* ---------- the gate ----------------------------------------------------- */
  /* Nothing is preselected. Shrine preselects the first available variant and
     writes `?variant=` into the address bar, so on a cold load we undo both,
     and we redo it after every variant change until the shopper has actually
     chosen a size. The button keeps `aria-disabled` rather than `disabled`: a
     disabled button fires no click, and the gate has to be able to send the
     shopper to the size grid. */

  function labelNode(button) {
    if (!button) return null;
    return button.querySelector('.main-atc__label__line-1 > span:not(.main-atc-price):not(.main-atc__label__icon)') ||
      button.querySelector('.sticky-atc__label__text') ||
      button.querySelector('.main-atc__label__text');
  }

  function setGate(button, gated) {
    if (!button) return;
    var node = labelNode(button);
    if (gated) {
      /* Shrine renders the button disabled and labelled "Slutsåld" whenever
         the variant it preselected is sold out. Nothing has been chosen yet,
         so the button has to read "Välj storlek" and stay clickable: the click
         handler below sends the shopper to the size grid. The original state
         is parked on the node and put back the moment a size is chosen. */
      if (button.disabled) {
        button.setAttribute('data-tj-disabled', 'true');
        button.disabled = false;
      }
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('tj-atc--gated');
      if (node) {
        if (!node.hasAttribute('data-tj-label')) {
          node.setAttribute('data-tj-label', node.textContent.trim());
        }
        if (node.textContent !== (LABELS.selectSize || 'Välj storlek')) {
          node.textContent = LABELS.selectSize || 'Välj storlek';
        }
      }
    } else {
      /* Handing the button back. The parked label and the parked disabled
         state describe the variant nobody chose, so they only go back when the
         size the shopper did choose is itself sold out. Shrine normally re
         renders the whole buy column a moment later and owns both again; this
         is what the button reads in the meantime, and if that render never
         arrives. Once Shrine or a back in stock app has written its own words
         onto this node they win, so the parked label is dropped untouched. */
      var chosenSoldOut = state.size ? !sizeAvailable(state.size) : false;

      if (node && node.hasAttribute('data-tj-label')) {
        if (node.textContent.trim() === (LABELS.selectSize || 'Välj storlek')) {
          var parked = node.getAttribute('data-tj-label') || '';
          node.textContent = chosenSoldOut
            ? parked || LABELS.addToCart || 'Lägg i varukorgen'
            : LABELS.addToCart || parked || 'Lägg i varukorgen';
        }
        node.removeAttribute('data-tj-label');
      }
      if (button.getAttribute('data-tj-disabled') === 'true') {
        button.removeAttribute('data-tj-disabled');
        if (chosenSoldOut) button.disabled = true;
      }
      button.removeAttribute('aria-disabled');
      button.classList.remove('tj-atc--gated');
    }
  }

  function stripVariantParam() {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.pathname + (url.search || '') + url.hash);
    } catch (e) {
      /* an exotic URL is not worth a thrown error in the buy box */
    }
  }

  function mirrorSticky(size) {
    var subtitle = $('.sticky-atc__subtitle');
    if (!subtitle) return;
    if (size) {
      subtitle.textContent = 'storlek ' + size;
      subtitle.setAttribute('data-tj-state', 'set');
    } else {
      subtitle.textContent = LABELS.noSize || 'storlek ej vald';
      subtitle.setAttribute('data-tj-state', 'unset');
    }
  }

  function unchosen(on) {
    var root = document.documentElement;
    if (!root || !root.classList) return;
    if (on) root.classList.add('tj-size-unchosen');
    else root.classList.remove('tj-size-unchosen');
  }

  function syncBuyColumn() {
    var group = sizeGroup();
    if (!group) {
      /* templates without a size grid (accessories) never gate */
      unchosen(false);
      return;
    }

    var checked = group.querySelector('input[type="radio"]:checked');

    if (state.sizeChosen) {
      if (checked) state.size = checked.value;
      unchosen(false);
      setGate(mainAtc(), false);
      setGate(stickyAtc(), false);
      mirrorSticky(state.size);
      return;
    }

    unchosen(true);
    clearShrineSelection(group);
    var idInput = variantIdInput();
    if (idInput && idInput.value) idInput.value = '';
    stripVariantParam();
    setGate(mainAtc(), true);
    setGate(stickyAtc(), true);
    mirrorSticky(null);

    /* our own writes must not wake the observer that called us */
    if (pickerObserver) pickerObserver.takeRecords();
  }

  var syncQueued = false;
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function () {
      syncQueued = false;
      syncBuyColumn();
      placePromo();
      placeSizeHelp();
      updateMeter();
      watchPickers();
      syncGalleryRail();
    });
    /* Shrine re renders the buy column asynchronously, so settle once more
       after its own write */
    window.setTimeout(function () {
      syncBuyColumn();
      placePromo();
      placeSizeHelp();
      updateMeter();
      watchPickers();
      syncGalleryRail();
    }, 350);
  }

  /* ---------- the gate survives a re render --------------------------------- */
  /* Shrine replaces the contents of `variant-selects` on every variant change
     and a swatch app rebuilds its own markup whenever it pleases, so the gate
     is re applied until the shopper picks a size. The counter is a stop: if
     something out there insists on selecting for us, the page settles instead
     of looping forever, and the button still reads "Välj storlek". */

  var pickerObserver = null;
  var observed = [];
  var reapplyTimer = null;
  var REAPPLY_LIMIT = 60;

  function watchPickers() {
    if (!window.MutationObserver) return;
    var roots = $$('variant-selects').concat($$('variant-swatch-king'));
    if (!roots.length) return;

    if (!pickerObserver) {
      pickerObserver = new MutationObserver(function () {
        if (state.sizeChosen) return;
        if (state.reapplies >= REAPPLY_LIMIT) return;
        window.clearTimeout(reapplyTimer);
        reapplyTimer = window.setTimeout(function () {
          state.reapplies += 1;
          syncBuyColumn();
          placePromo();
        }, 80);
      });
    }

    roots.forEach(function (root) {
      if (observed.indexOf(root) !== -1) return;
      observed.push(root);
      pickerObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'aria-checked', 'data-selected']
      });
    });
  }

  /* A swatch app hides Shrine's picker, so the element to scroll to and the
     element to focus are not always the group that owns the radios. */
  function isLaidOut(node) {
    return !!(node && node.getClientRects && node.getClientRects().length);
  }

  /* the size row the shopper can actually see, whichever picker draws it */
  function visibleSizeAnchor() {
    var group = sizeGroup();
    if (isLaidOut(group)) return group;
    return appSizeGroups().filter(isLaidOut)[0] || group;
  }

  function focusSizeGrid() {
    var group = sizeGroup();
    var anchor = visibleSizeAnchor();
    if (!anchor) return;
    scrollToElement(anchor);

    if (isLaidOut(group)) {
      var radios = sizeRadios(group);
      for (var i = 0; i < radios.length; i++) {
        if (!isSoldOut(radios[i])) {
          radios[i].focus({ preventScroll: true });
          return;
        }
      }
      if (radios[0]) radios[0].focus({ preventScroll: true });
      return;
    }

    var cells = $$('[role="radio"]', anchor).filter(isLaidOut);
    for (var j = 0; j < cells.length; j++) {
      if (!cells[j].classList.contains('swatch-item-unavailable')) {
        cells[j].focus({ preventScroll: true });
        return;
      }
    }
    if (cells[0]) cells[0].focus({ preventScroll: true });
  }

  /* A preselection arrives as a synthetic click on the hidden radio, so it is
     cancelled here rather than undone afterwards: cancelling a radio's click
     restores its checkedness, and nothing downstream ever sees a change. A
     real tap, and a tap forwarded by a swatch app milliseconds later, both
     pass the trusted test and go through untouched. */
  document.addEventListener(
    'click',
    function (e) {
      if (state.sizeChosen) return;
      var radio = e.target;
      if (!radio || radio.tagName !== 'INPUT' || radio.type !== 'radio') return;
      if (shopperDriven(e)) return;
      var group = sizeGroup();
      if (!group || !group.contains(radio)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      queueSync();
    },
    true
  );

  /* a click on the gated button is a request for the size grid, not an error */
  document.addEventListener(
    'click',
    function (e) {
      var button = closest(e.target, '.tj-atc--gated[aria-disabled="true"]');
      if (!button) return;
      e.preventDefault();
      e.stopPropagation();
      focusSizeGrid();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (!state.sizeChosen && sizeGroup() && closest(e.target, 'product-form')) {
        e.preventDefault();
        focusSizeGrid();
      }
    },
    true
  );

  /* ---------- size selection ------------------------------------------------ */

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio || radio.type !== 'radio') return;
    var group = sizeGroup();
    if (!group || !group.contains(radio)) {
      queueSync();
      return;
    }
    if (!radio.checked) return;

    /* whatever slipped past the click guard is still a preselection, not a
       choice, so it is undone rather than trusted */
    if (!state.sizeChosen && !shopperDriven(e)) {
      queueSync();
      return;
    }

    state.sizeChosen = true;
    state.size = radio.value;
    track('tj_size_selected', { tj_size: radio.value, tj_available: !isSoldOut(radio) });
    if (isSoldOut(radio)) {
      track('tj_waitlist_open', { tj_size: radio.value });
    }
    queueSync();
  });

  /* ---------- the size finder ------------------------------------------------ */

  /* A finder that can never answer is worse than none. Liquid already skips
     the section when the product has no table; this covers a table whose rows
     carry no usable length. The section, the sage promo and the "Osäker på
     storleken" link go together. */
  function retireFinder(root) {
    var section = closest(root, '.shopify-section') || closest(root, '.tj-finder');
    if (section) section.hidden = true;
    var promo = $('[data-tj-promo]');
    if (promo) promo.hidden = true;
    var anchor = $('#matdinfot');
    if (anchor) anchor.removeAttribute('id');
    if (sizeHelpLink && sizeHelpLink.parentNode) sizeHelpLink.parentNode.removeChild(sizeHelpLink);
    state.finderRetired = true;
  }

  function initFinder(root) {
    var script = root.parentNode ? root.parentNode.querySelector('[data-tj-size-table]') : null;
    var input = $('[data-tj-foot]', root);
    if (!input) return;
    if (!script || !RULE) {
      retireFinder(root);
      return;
    }

    var table;
    try {
      table = JSON.parse(script.textContent);
    } catch (e) {
      retireFinder(root);
      return;
    }
    if (!table || !table.rows || !table.rows.length) {
      retireFinder(root);
      return;
    }

    var result = $('[data-tj-result]', root);
    var empty = $('[data-tj-empty]', root);
    var out = $('[data-tj-out]', root);
    var alt = $('[data-tj-alt]', root);
    var use = $('[data-tj-use]', root);
    var tableEl = $('.tj-stable', root);

    var sizeCol = intAttr(root, 'data-size-col', 0);
    var lenCol = intAttr(root, 'data-length-col', 1);
    var ruleMin = floatAttr(root, 'data-rule-min', CFG.ruleMin || 1.0);
    var ruleMax = floatAttr(root, 'data-rule-max', CFG.ruleMax || 1.5);
    var child = root.getAttribute('data-audience') === 'child';
    var range = RULE.bounds(child);
    var minCm = range.min;
    var maxCm = range.max;

    /* the rule itself: assets/tj-size-rule.js */
    var prepared = RULE.prepare(table, { sizeCol: sizeCol, lenCol: lenCol });
    if (!prepared) {
      retireFinder(root);
      return;
    }
    var rows = prepared.rows;
    var byFoot = prepared.byFoot;
    var extraCol = prepared.extraCol;
    var extraName = prepared.extraName;

    function markTable(size) {
      if (!tableEl) return;
      $$('tr[data-size]', tableEl).forEach(function (tr) {
        if (size && sameSize(tr.getAttribute('data-size'), size)) tr.setAttribute('data-match', 'true');
        else tr.removeAttribute('data-match');
      });
    }

    function showEmpty(message, withContact) {
      if (result) result.setAttribute('data-state', 'empty');
      if (empty) {
        empty.textContent = message;
        if (withContact && root.getAttribute('data-contact-url')) {
          empty.appendChild(document.createTextNode(' '));
          var link = document.createElement('a');
          link.href = root.getAttribute('data-contact-url');
          link.textContent = root.getAttribute('data-contact-label') || 'Kontakta oss';
          empty.appendChild(link);
        }
      }
      if (alt) {
        alt.textContent = '';
        alt.hidden = true;
      }
      if (use) {
        use.hidden = true;
        use.removeAttribute('data-size');
      }
      markTable(null);
    }

    function showResult(pick, room, below) {
      if (result) result.setAttribute('data-state', 'ok');

      if (out) {
        out.textContent = '';

        var sizeEl = document.createElement('span');
        sizeEl.className = 'tj-fnd__size';
        sizeEl.textContent = pick.size;

        var detail = document.createElement('span');
        detail.className = 'tj-fnd__detail';

        var strong = document.createElement('b');
        strong.textContent = fill(root.getAttribute('data-text-room') || '{room} cm framför tårna', {
          room: cm(room)
        });
        detail.appendChild(strong);
        detail.appendChild(document.createElement('br'));

        var line = fill(root.getAttribute('data-text-inner') || 'Innerlängd {inner} cm', {
          inner: cm(pick.inner)
        });
        if (extraCol > -1 && pick.cells[extraCol] && extraName) {
          line += ', ' +
            extraName.toLowerCase().replace(' i cm', '').trim() + ' ' +
            String(pick.cells[extraCol]).replace('.', ',') + ' cm';
        }
        if (byFoot && pick.range) {
          line += ', ' + fill(root.getAttribute('data-text-footrange') || 'passar fotlängd {lo} till {hi} cm', {
            lo: cm(pick.range.lo),
            hi: cm(pick.range.hi)
          });
        }
        detail.appendChild(document.createTextNode(line));

        out.appendChild(sizeEl);
        out.appendChild(detail);
      }

      var notes = [];
      /* a sold out smaller size is not an alternative worth offering */
      if (!byFoot && room > ruleMax && below && sizeAvailable(below.size)) {
        notes.push(
          fill(root.getAttribute('data-text-roomy') || '', {
            size: pick.size,
            alt: below.size,
            altRoom: cm(below.inner - foot())
          })
        );
      }
      if (!sizeAvailable(pick.size)) {
        notes.push(fill(root.getAttribute('data-text-soldout') || '', { size: pick.size }));
      }
      if (alt) {
        alt.textContent = notes.join(' ');
        alt.hidden = notes.length === 0;
      }

      if (use) {
        use.hidden = false;
        use.setAttribute('data-size', pick.size);
        use.textContent = fill(root.getAttribute('data-text-use') || 'Använd storlek {size}', {
          size: pick.size
        });
      }

      markTable(pick.size);
    }

    function foot() {
      return RULE.parseFoot(input.value);
    }

    function calc() {
      var raw = String(input.value || '').replace(',', '.').trim();

      if (!raw) {
        showEmpty(root.getAttribute('data-text-empty') || '');
        return;
      }

      var value = parseFloat(raw);
      if (isNaN(value) || value < minCm || value > maxCm) {
        showEmpty(root.getAttribute('data-text-invalid') || '');
        return;
      }

      if (!state.finderUsed) {
        state.finderUsed = true;
        track('tj_size_finder_used', { tj_audience: child ? 'child' : 'adult' });
      }

      var res = RULE.pick(prepared, value, { ruleMin: ruleMin, ruleMax: ruleMax });

      if (res.status === 'short') {
        showEmpty(fill(root.getAttribute('data-text-short') || '', { size: res.edge.size }), true);
        return;
      }

      if (res.status === 'long') {
        showEmpty(fill(root.getAttribute('data-text-long') || '', { size: res.edge.size }), true);
        return;
      }

      var pick = res.pick;
      var below = res.below;
      var room = pick.inner - value;
      showResult(pick, room, below);
      track('tj_size_finder_result', {
        tj_size: pick.size,
        tj_foot_cm: value,
        tj_room_cm: Math.round(room * 10) / 10
      });
    }

    input.addEventListener('input', calc);

    if (use) {
      use.addEventListener('click', function () {
        var size = use.getAttribute('data-size');
        if (!size) return;
        var radio = radioForSize(size);
        track('tj_size_finder_applied', { tj_size: size, tj_found: !!radio });
        if (!radio) return;

        state.sizeChosen = true;
        state.size = size;

        /* When a swatch app owns the visible picker, clicking its own cell is
           what keeps its UI, the radios and the form in step. This click sits
           inside the shopper's own trusted window, so the gate reads it as a
           choice. Without an app, the radio is driven directly. */
        var cell = appCellForSize(size);
        if (cell && !isLaidOut(sizeGroup())) {
          cell.click();
        } else {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Back to the size grid, not to the top of the buy column: on a phone
           the top of the main section is the gallery, so the shopper landed
           three screens above the chip they had just been given. */
        scrollToElementSettled(visibleSizeAnchor() || mainForm());
        window.setTimeout(
          function () {
            var again = radioForSize(size);
            if (again) again.focus({ preventScroll: true });
          },
          REDUCE ? 0 : 420
        );
      });
    }

    calc();
  }

  /* ---------- the finder promo ------------------------------------------------ */
  /* The promo is a block in the details container, directly under the variant
     picker, at every width: that is where the size question is asked, and the
     sage panel no longer moves between two columns as the viewport changes.
     The reparenting below is a fallback for a page whose promo block still
     sits in the gallery column, and it is a no op as soon as the promo is
     already in the buy column. One node, never a duplicate. */

  var placePromo = function () {};

  function inGalleryColumn(node) {
    return !!closest(node, '.product__media-wrapper');
  }

  function initPromo() {
    var promo = $('[data-tj-promo]');
    var group = sizeGroup();
    if (!promo || !group) return;
    if (!inGalleryColumn(promo)) return; /* already under the size grid */

    var home = promo.parentNode;
    var after = promo.nextElementSibling;
    var mq = window.matchMedia('(max-width: 1023px)');

    placePromo = function () {
      var target = sizeGroup();
      if (!target) return;
      /* anchor on the whole picker, never inside it: Shrine replaces the
         markup of `variant-selects` on a variant change and would take the
         promo with it */
      var anchor = target.parentNode && target.parentNode.tagName === 'VARIANT-SELECTS'
        ? target.parentNode
        : target;
      if (mq.matches) {
        if (promo.previousElementSibling !== anchor) {
          anchor.parentNode.insertBefore(promo, anchor.nextSibling);
        }
      } else if (promo.parentNode !== home) {
        home.insertBefore(promo, after);
      }
    };

    placePromo();
    if (mq.addEventListener) mq.addEventListener('change', placePromo);
    else window.addEventListener('resize', placePromo, { passive: true });
  }

  /* ---------- the size help link ---------------------------------------------- */
  /* "Osäker på storleken? Mät din fot" sits on the right of the Storlek label
     row and scrolls to the size finder. The row belongs to whichever picker is
     on screen: Shrine prints `.product-form__label-container`, and the swatch
     app prints `.swatch-label-container`. The link is created once and moved,
     never copied, so a picker re render cannot leave two of them behind. */

  var sizeHelpLink = null;

  function sizeHelpRow() {
    var app = appSizeGroups().filter(isLaidOut)[0];
    if (app) {
      var appRow = app.querySelector('.swatch-label-container');
      if (appRow) return appRow;
    }
    var group = sizeGroup();
    if (isLaidOut(group)) {
      return group.querySelector('.product-form__label-container') || group;
    }
    return null;
  }

  function placeSizeHelp() {
    var label = LABELS.sizeHelp || 'Osäker på storleken? Mät din fot';
    if (!label) return;
    var anchorId = CFG.finderAnchor || '#matdinfot';
    if (!document.querySelector(anchorId)) return;

    var row = sizeHelpRow();
    if (!row) return;

    if (!sizeHelpLink) {
      sizeHelpLink = document.createElement('a');
      sizeHelpLink.className = 'tj-sizehelp';
      sizeHelpLink.href = anchorId;
      sizeHelpLink.textContent = label;
      sizeHelpLink.setAttribute('data-tj-scroll', '');
      sizeHelpLink.setAttribute('data-tj-sizehelp', '');
      bindScrollLink(sizeHelpLink);
    }
    if (sizeHelpLink.parentNode !== row) row.appendChild(sizeHelpLink);
  }

  /* ---------- free shipping meter -------------------------------------------- */
  /* Contract, so the block and this file can be read apart:
       [data-tj-meter]            root, data-threshold, data-base-price,
                                  data-cart-total (all in öre),
                                  data-text-gap with {gap} and {threshold},
                                  data-text-done
       [data-tj-meter-total]      the running total
       [data-tj-meter-bar]        scaleX from 0 to 1
       [data-tj-meter-gap]        the whole sentence: data-text-gap with {gap}
                                  and {threshold} filled in, or data-text-done
       [data-tj-meter-amount]     optional, the bare gap on its own
     Recomputed on variant change, on the add on rows, on quantity and on a
     cart update. */

  function variantsJson() {
    var script = $('variant-selects script[type="application/json"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentVariantPrice(fallback) {
    var idInput = variantIdInput();
    var id = idInput ? parseInt(idInput.value, 10) : NaN;
    if (!isNaN(id)) {
      var variants = variantsJson();
      if (variants) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === id) return variants[i].price;
        }
      }
    }
    return fallback;
  }

  function quantity() {
    var input = $('.product-form__quantity-and-btn input[name="quantity"]') ||
      $('form[data-type="add-to-cart-form"] input[name="quantity"]') ||
      $('input.quantity__input');
    var q = input ? parseInt(input.value, 10) : 1;
    return isNaN(q) || q < 1 ? 1 : q;
  }

  /* ---------- add on prices --------------------------------------------- */
  /* `snippets/upsell-block.liquid` prints the price and the compare at price
     as two sibling spans inside one `.upsell__price`, and the compare span is
     only given a `hidden` class, so it is still part of `textContent`.
     Reading the whole node ran the two numbers together: a 99 kr add on beside
     its own 99 kr compare price read as 9 999 kr and the buy box total went
     from 1 699 kr to 11 698 kr, and a 209 kr proofer with a 229 kr compare
     price read as 209 229 kr. One number, from one node. */

  /* `data-price` is only printed when the upsell block's "Update prices"
     setting is on (upsell-block.liquid line 171). It carries
     `variant.price | times: percentage_left | minus: fixed_discount`, and
     `variant.price` is öre, the same unit as the meter's own
     `data-base-price`, so the attribute is öre too. Those float filters can
     leave a fraction of an öre behind on a percentage discount, hence the
     round rather than a parseInt that would truncate. */
  function attrPrice(el, name) {
    if (!el || !el.getAttribute) return NaN;
    var raw = el.getAttribute(name || 'data-price');
    if (raw === null || raw === '') return NaN;
    var value = parseFloat(String(raw).replace(',', '.'));
    if (isNaN(value) || value < 0) return NaN;
    return Math.round(value);
  }

  /* the first money token only: "209 kr229 kr" is a price and its struck
     compare price, not one number */
  function firstMoneyToCents(text) {
    var match = /\d[\d\s\u00a0.,']*/.exec(String(text || ''));
    return match ? moneyToCents(match[0]) : NaN;
  }

  /* in priority order, so a node that holds the current price is read before
     any container that holds both prices */
  var PRICE_SELECTORS = [
    '.price-item--sale',
    '.price-item--regular',
    '.upsell__price .regular-price',
    '.regular-price',
    '.upsell__price',
    '.price'
  ];

  function printedPrice(node) {
    if (!node || !node.querySelector) return NaN;
    for (var i = 0; i < PRICE_SELECTORS.length; i++) {
      var el = node.querySelector(PRICE_SELECTORS[i]);
      if (!el) continue;
      var cents = firstMoneyToCents(el.textContent);
      if (!isNaN(cents)) return cents;
    }
    return NaN;
  }

  function addonTotal() {
    var total = 0;

    $$('product-info-upsell[data-selected="true"]').forEach(function (node) {
      var price = attrPrice(node, 'data-price');
      if (isNaN(price)) price = printedPrice(node);
      if (!isNaN(price)) total += price;
    });

    $$('[data-tj-addon]').forEach(function (node) {
      var input = node.matches('input') ? node : node.querySelector('input[type="checkbox"]');
      if (!input || !input.checked) return;
      var price = attrPrice(node, 'data-price');
      if (isNaN(price)) price = attrPrice(input, 'data-price');
      if (isNaN(price)) price = printedPrice(node);
      if (!isNaN(price)) total += price;
    });

    return total;
  }

  function updateMeter() {
    var root = $('[data-tj-meter]');
    if (!root) return;

    var threshold = parseInt(root.getAttribute('data-threshold'), 10);
    if (isNaN(threshold)) threshold = parseInt(CFG.threshold, 10) || 170000;

    var base = parseInt(root.getAttribute('data-base-price'), 10);
    if (isNaN(base)) base = 0;
    base = currentVariantPrice(base) * quantity();

    var cart = parseInt(root.getAttribute('data-cart-total'), 10);
    if (isNaN(cart)) cart = 0;

    var sum = base + addonTotal() + cart;
    var gap = Math.max(0, threshold - sum);
    var ratio = threshold > 0 ? Math.min(1, sum / threshold) : 1;

    var totalNode = $('[data-tj-meter-total]', root);
    if (totalNode) totalNode.textContent = moneyTrim(sum);

    var bar = $('[data-tj-meter-bar]', root);
    if (bar) bar.style.transform = 'scaleX(' + ratio.toFixed(3) + ')';

    /* [data-tj-meter-gap] holds the whole sentence, exactly as the block
       renders it server side; [data-tj-meter-amount] is optional and holds
       the bare number for the big variant of the meter */
    var gapNode = $('[data-tj-meter-gap]', root);
    if (gapNode) {
      gapNode.textContent = gap > 0
        ? fill(root.getAttribute('data-text-gap') || '', {
            gap: moneyTrim(gap),
            threshold: moneyTrim(threshold)
          })
        : root.getAttribute('data-text-done') || '';
    }

    var amountNode = $('[data-tj-meter-amount]', root);
    if (amountNode) amountNode.textContent = gap > 0 ? moneyTrim(gap) : '';

    root.setAttribute('data-tj-reached', gap > 0 ? 'false' : 'true');

    if (gap <= 0 && !state.shippingReached) {
      state.shippingReached = true;
      track('tj_free_shipping_reached', { tj_total: sum, tj_threshold: threshold });
    } else if (gap > 0) {
      state.shippingReached = false;
    }
  }

  function watchAddons() {
    /* Shrine re renders the add on rows when its dynamic recommendations
       arrive (as soon as the block scrolls into view), so the rows present at
       start are not the rows the shopper clicks. The observer watches the
       whole buy column instead of the first rows, or the total stops
       following the checkboxes after the first re render. */
    var root = $('.product__info-container') || ($('product-info-upsell') ? document.body : null);
    if (root && window.MutationObserver) {
      var observer = new MutationObserver(function (records) {
        var changed = false;
        records.forEach(function (record) {
          var node = record.target;
          if (!node || node.tagName !== 'PRODUCT-INFO-UPSELL') return;
          changed = true;
          if (addonSync.silent) return;
          track('tj_addon_toggled', {
            tj_addon_id: node.getAttribute('data-id') || '',
            tj_selected: node.getAttribute('data-selected') === 'true'
          });
        });
        if (changed) updateMeter();
      });
      observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['data-selected'] });
    }

    document.addEventListener('change', function (e) {
      var addon = closest(e.target, '[data-tj-addon]');
      if (addon) {
        track('tj_addon_toggled', {
          tj_addon_id: addon.getAttribute('data-id') || '',
          tj_selected: !!(e.target.checked)
        });
        updateMeter();
        return;
      }
      if (e.target && e.target.name === 'quantity') updateMeter();
    });

    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') updateMeter();
    });
  }

  function refreshCartTotal() {
    var root = $('[data-tj-meter]');
    if (!root || !window.fetch) return;
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          root.setAttribute('data-cart-total', String(cart.total_price));
          updateMeter();
        }
      })
      .catch(function () {
        /* the meter keeps the server rendered total */
      });
  }

  /* ---------- ticked add ons reach the cart (release fix, 2026-10-23) -----------
     Shrine posts the ticked add on rows together with the main item, but the
     Vitals pre purchase popup takes over the product form and posts only the
     main variant, so the add ons the buy box total promised were dropped.
     Whatever path adds the main item (theme form, sticky bar, Vitals "Nej
     tack" or its own add), the ticked rows are noted at the add click, and
     once a /cart/add call has finished and the main variant is in the cart,
     every noted add on that is not in the cart yet is added with quantity 1.
     An add on already in the cart is never added twice; a sold out or failing
     add on is skipped and the main item stays. */

  var addonSync = { pending: null, busy: false, timer: 0, silent: false };
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;

  function tickedAddonIds() {
    var ids = [];
    function push(id) {
      id = String(id || '').trim();
      if (/^\d+$/.test(id) && ids.indexOf(id) === -1) ids.push(id);
    }
    $$('product-info-upsell[data-selected="true"]').forEach(function (node) {
      var input = node.querySelector('input[name="id"]');
      push(node.getAttribute('data-id') || (input && input.value));
    });
    $$('[data-tj-addon]').forEach(function (node) {
      var input = node.matches('input') ? node : node.querySelector('input[type="checkbox"]');
      if (!input || !input.checked) return;
      push(node.getAttribute('data-variant-id') || node.getAttribute('data-id') || input.getAttribute('data-id') || input.value);
    });
    return ids;
  }

  function noteAddons(e) {
    var button = closest(e.target, '.product-form__submit, .sticky-atc__add_button, button[type="submit"]');
    var form = mainForm();
    if (e.type !== 'submit') {
      if (!button) return;
      var isMain = button.classList.contains('sticky-atc__add_button') ||
        (form && (form.contains(button) || button.getAttribute('form') === form.id)) ||
        button === mainAtc();
      if (!isMain) return;
      if (button.getAttribute('aria-disabled') === 'true' || button.disabled) return;
    } else if (!form || e.target !== form) {
      return;
    }
    var idInput = variantIdInput();
    var ids = tickedAddonIds();
    addonSync.pending = ids.length && idInput && idInput.value
      ? { ids: ids, variant: String(idInput.value), at: Date.now() }
      : null;
  }

  /* Once the main item is in, the ticked rows are in the cart too, so they are
     unticked: the buy box total then counts them once (as cart total), and a
     second add, by any path, adds only the main item again. */
  function clearTicks(ids) {
    addonSync.silent = true;
    $$('product-info-upsell[data-selected="true"]').forEach(function (node) {
      if (ids.indexOf(String(node.getAttribute('data-id'))) !== -1) node.setAttribute('data-selected', 'false');
    });
    $$('[data-tj-addon]').forEach(function (node) {
      var input = node.matches('input') ? node : node.querySelector('input[type="checkbox"]');
      if (input && input.checked) input.checked = false;
    });
    window.setTimeout(function () {
      addonSync.silent = false;
      refreshCartTotal();
    }, 0);
  }

  function addonDrawer(payload) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && payload && payload.sections) {
      drawer.renderContents(payload);
      drawer.classList.remove('is-empty');
    } else if (rawFetch) {
      rawFetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (response) { return response.json(); })
        .then(function (sections) {
          var read = function (html, selector) {
            var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
            return node ? node.innerHTML : null;
          };
          var target = document.querySelector('#CartDrawer');
          var markup = target && sections['cart-drawer'] ? read(sections['cart-drawer'], '#CartDrawer') : null;
          if (markup !== null) target.innerHTML = markup;
          var bubble = document.getElementById('cart-icon-bubble');
          var bubbleMarkup = bubble && sections['cart-icon-bubble'] ? read(sections['cart-icon-bubble'], '.shopify-section') : null;
          if (bubbleMarkup !== null) bubble.innerHTML = bubbleMarkup;
          if (drawer) drawer.classList.remove('is-empty');
        })
        .catch(function () {});
    }
    if (typeof window.publish === 'function') window.publish('cart-update', { source: 'tj-addons' });
    document.dispatchEvent(new CustomEvent('cart-update', { detail: { source: 'tj-addons' } }));
    refreshCartTotal();
  }

  function postAdd(items) {
    return rawFetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (response) {
      return response.json().then(function (json) {
        return response.ok ? json : Promise.reject(json);
      });
    });
  }

  function reconcileAddons() {
    var pending = addonSync.pending;
    if (!pending || addonSync.busy || !rawFetch) return;
    if (Date.now() - pending.at > 180000) {
      addonSync.pending = null;
      return;
    }
    addonSync.busy = true;
    rawFetch(ROOT_URL + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) { inCart[String(item.variant_id)] = true; });
        /* the main item is not in yet: this add was another step (a popup's own
           product); keep the note for the add that follows */
        if (!inCart[pending.variant]) return null;
        addonSync.pending = null;
        clearTicks(pending.ids);
        var missing = pending.ids.filter(function (id) { return !inCart[id]; });
        if (!missing.length) return null;
        var items = missing.map(function (id) { return { id: Number(id), quantity: 1 }; });
        return postAdd(items)
          .then(function (payload) {
            return { payload: payload, added: missing };
          })
          .catch(function () {
            /* one add on is sold out or refused: add the others one by one */
            var added = [];
            var last = null;
            return missing.reduce(function (chain, id) {
              return chain.then(function () {
                return postAdd([{ id: Number(id), quantity: 1 }])
                  .then(function (payload) { added.push(id); last = payload; })
                  .catch(function () {});
              });
            }, Promise.resolve()).then(function () {
              return { payload: last, added: added };
            });
          })
          .then(function (result) {
            addonDrawer(result.payload);
            if (result.added.length) {
              track('tj_addon_added', { tj_addon_ids: result.added.join(','), tj_count: result.added.length });
            }
          });
      })
      .catch(function () {})
      .then(function () {
        addonSync.busy = false;
      });
  }

  function cartAddSeen() {
    if (!addonSync.pending) return;
    window.clearTimeout(addonSync.timer);
    addonSync.timer = window.setTimeout(reconcileAddons, 500);
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || ''));
  }

  function watchCartAdds() {
    /* window capture, and pointerdown too: an app that stops the click on its
       way down must not hide the add from us */
    window.addEventListener('pointerdown', noteAddons, true);
    window.addEventListener('click', noteAddons, true);
    window.addEventListener('submit', noteAddons, true);

    /* every path that can add the main item: fetch, XHR, and as a fallback
       for a script that kept its own fetch reference, resource timing */
    if (window.fetch && !window.fetch.tjAddons) {
      var pageFetch = window.fetch;
      var wrapped = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var result = pageFetch.apply(this, arguments);
        if (isCartAdd(url)) {
          result.then(function (response) { if (response && response.ok) cartAddSeen(); }, function () {});
        }
        return result;
      };
      wrapped.tjAddons = true;
      window.fetch = wrapped;
    }

    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.tjAddons) {
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (isCartAdd(url)) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) cartAddSeen();
          });
        }
        return open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.tjAddons = true;
    }

    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (isCartAdd(entry.name.replace(/^https?:\/\/[^/]+/, ''))) cartAddSeen();
          });
        }).observe({ type: 'resource', buffered: false });
      } catch (err) {
        /* fetch and XHR still cover the theme and the app */
      }
    }
  }

  watchCartAdds();

  /* ---------- add to cart tracking -------------------------------------------- */

  document.addEventListener('click', function (e) {
    var button = closest(e.target, 'button, a');
    if (!button) return;

    var source = button.getAttribute('data-tj-atc-source');
    if (!source) {
      if (button.classList.contains('sticky-atc__add_button')) source = 'sticky';
      else if (button.classList.contains('product-form__submit')) source = 'main';
      else if (closest(button, '[data-tj-care-set]')) source = 'care_set';
      else if (closest(button, 'product-info-upsell')) source = 'addon';
    }
    if (!source) return;
    if (button.getAttribute('aria-disabled') === 'true' || button.disabled) return;

    track('tj_add_to_cart', { tj_source: source, tj_size: state.size || '' });
  });

  /* ---------- annotated image, the one motion moment --------------------------- */

  function initLeaders() {
    var stages = $$('[data-tj-annot]');
    if (!stages.length || REDUCE) return;

    stages.forEach(function (stage) {
      var leaders = $$('[data-tj-leader]', stage);
      if (!leaders.length) return;

      leaders.forEach(function (leader) {
        leader.style.transformOrigin = leader.getAttribute('data-origin') || 'left center';
        leader.style.transform = 'scaleX(0)';
        leader.style.transition = 'transform 520ms cubic-bezier(0.23, 1, 0.32, 1)';
      });

      function draw() {
        leaders.forEach(function (leader) {
          leader.style.transform = 'scaleX(1)';
        });
      }

      if (window.IntersectionObserver) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                draw();
                observer.disconnect();
              }
            });
          },
          { rootMargin: '0px 0px -15% 0px' }
        );
        observer.observe(stage);
      } else {
        draw();
      }

      /* a jump scroll or a headless render must never leave a line undrawn */
      window.setTimeout(draw, 4000);
    });
  }

  /* ---------- the phone photo rail --------------------------------------------- */
  /* Below 990px the gallery is one horizontal rail, and a flex row is as tall
     as its tallest cell, so a product whose photos are not all the same shape
     leaves dead ground under the short ones (measured on 511 Grå at 390: a
     390 x 390 first cell sitting in a 585px row, so 195px of nothing).

     The rail takes the shape of the first photo, which is the one the shopper
     lands on and the one the colour choice controls. Nothing is invented: a
     product shot in 3:2 keeps 3:2, a square hero gives a square rail, and a
     product whose photos already match looks exactly as it does today.
     `assets/tj-pdp.css` reads the value; above 990px the column pattern there
     wins and this variable is unused.

     A photo whose own shape is far from the rail's would lose a third of
     itself to the theme's cover fit, and on a packshot that third is the shoe,
     so it is marked to sit whole on the mist ground instead. */

  var RAIL_MIN = 0.62; /* 390 x 629, about one phone screen tall */
  var RAIL_MAX = 1.6; /* 390 x 244, a wide packshot band */
  var RAIL_TOLERANCE = 0.2; /* how far a photo may be off the rail and still fill it */

  function mediaRatio(container) {
    var own = parseFloat(window.getComputedStyle(container).getPropertyValue('--preview-ratio'));
    if (!isNaN(own) && own > 0) return own;
    var img = container.querySelector('img');
    if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
      return img.naturalWidth / img.naturalHeight;
    }
    return NaN;
  }

  var railSyncing = false;

  function syncGalleryRail() {
    if (railSyncing) return;
    railSyncing = true;
    try {
      applyColourFilter();
      applyGalleryRail();
      layoutGalleryGrid();
    } finally {
      /* our own writes must not wake the observer that called us */
      galleryObservers.forEach(function (observer) {
        observer.takeRecords();
      });
      railSyncing = false;
    }
  }

  /* ---------- the colour filter ------------------------------------------------ */
  /* Every alt text in this catalogue is the same SEO string on all of a
     product's media, so Shrine's alt based filter cannot tell one colour from
     another and the page shows seven photographs of the chocolate boot while
     Svart is selected. The filenames do carry the colour, so a per template map
     ties each option 1 value to the tokens its filenames use:

       data-tj-colour-map="Svart=black|svart;Brun=chocolate|brown|brun"

     printed by `blocks/tj-size-promo.liquid`. A media whose filename matches
     no colour in the map at all (a flat lay, a detail shot) always stays. When
     there is no map, or the selected colour matches nothing, every media stays
     visible, which is today's behaviour. The theme's own `hidden` class is
     used so the gallery's counters and the rail agree with what is on screen;
     `data-tj-colour="off"` marks the ones we hid so a later pass can only ever
     put our own back.
     Since patch 3p the map is one of several sources: `tjGroupMedia` below
     groups every photo by colour, and a product without grouping data hides
     nothing. */

  function colourMap() {
    var node = $('[data-tj-colour-map]');
    var raw = node ? node.getAttribute('data-tj-colour-map') : '';
    if (!raw) return null;
    var map = {};
    var any = false;
    String(raw).split(';').forEach(function (entry) {
      var parts = entry.split('=');
      if (parts.length < 2) return;
      var name = parts[0].trim().toLowerCase();
      var tokens = parts.slice(1).join('=').split('|')
        .map(function (t) { return t.trim().toLowerCase(); })
        .filter(function (t) { return t.length > 1; });
      if (!name || !tokens.length) return;
      map[name] = tokens;
      any = true;
    });
    return any ? map : null;
  }

  /* option 1 is the colour on this catalogue ("Modell" on Be Lenka). The size
     group is skipped by name, never by index. */
  function selectedColour() {
    var size = sizeGroup();
    var groups = $$('variant-selects .product-form__input');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i] === size) continue;
      var radio = groups[i].querySelector('input[type="radio"]:checked');
      if (radio) return String(radio.value).trim().toLowerCase();
      var select = groups[i].querySelector('select');
      if (select && select.value) return String(select.value).trim().toLowerCase();
    }
    var cell = $('variant-swatch-king [option-target="option1"] [role="radio"][aria-checked="true"]');
    if (cell) {
      var value = cell.getAttribute('orig-value') || cell.getAttribute('data-value') || cell.getAttribute('aria-label');
      if (value) return String(value).trim().toLowerCase();
    }
    return '';
  }

  /* tj-colour-groups:start */
  /* Patch 3p. Which colour each photo belongs to, from the product's own data,
     most reliable first:
       1. Shopify's variant to media link (each colour's featured photo);
       2. colour words in the filename: the Swedish value, its supplier words
          (Svart = black, Brun = brown/cognac/chocolate ...), the template's
          `data-tj-colour-map` (3b) and the words only that colour's featured
          filename carries (`green-teal`, `desert-stone`, `cognac`);
       3. the alt text, only when the product's alts are not all the same;
       4. a photo with no word of its own that sits between two photos of the
          same colour (at most two in a row) belongs to that colour.
     The longest phrase wins and a tie leaves the photo shared. The product
     counts as grouped only when step 2 or 3 gives photos to two colours;
     otherwise nothing is hidden. Pure function, also run by the QA script. */
  var TJ_COLOUR_WORDS = {
    svart: ['black'], vit: ['white'], 'grå': ['grey', 'gray'], brun: ['brown', 'cognac', 'chocolate'],
    beige: ['beige', 'nude'], rosa: ['pink', 'rose'], 'röd': ['red'], 'blå': ['blue'], 'grön': ['green'],
    gul: ['yellow'], bordeaux: ['bordeaux', 'burgundy', 'berry', 'wine'], burgundy: ['bordeaux', 'burgundy', 'berry', 'wine'],
    marin: ['navy', 'marine'], natur: ['natural', 'nature'], oliv: ['olive'], guld: ['gold'], gold: ['gold'],
    silver: ['silver'], turkos: ['turquoise'], sand: ['sand'], plommon: ['plum'], senapsgul: ['mustard'],
    'roséguld': ['rose-gold'], kamel: ['camel'], denim: ['denim'], indigo: ['indigo'], jade: ['jade'],
    terracotta: ['terracotta'], toffee: ['toffee'], tabacco: ['tobacco', 'tabacco'], granit: ['granite']
  };
  var TJ_COLOUR_PREFIX = { 'mörk': 'dark', ljus: 'light', kungs: 'royal', matt: 'matt', skogs: 'forest', natur: 'natural' };
  var TJ_COLOUR_STOP = ['tjakko', 'barefoot', 'barfota', 'size', 'large', 'small', 'kids', 'copy', 'png', 'jpg', 'jpeg', 'webp', 'gif', 'and', 'och', 'med', 'for', 'the', 'stl',
    'tenisky', 'topanky', 'detske', 'cizmy', 'sandale', 'polobotky', 'baleriny', 'boty', 'obuv', 'zimni', 'kotnikove', 'damske', 'panske', 'chelsea'];

  function tjFold(s) {
    return String(s || '').toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/é/g, 'e');
  }

  function tjWords(s) {
    return tjFold(s).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 0; });
  }

  /* phrases for one colour value: [{ words: [...], weight }] */
  function tjColourPhrases(value) {
    var out = [];
    var parts = String(value).toLowerCase().split(/\s*(?:&|\+|\/|,|\soch\s|\smed\s|\s-\s)\s*/).filter(Boolean);
    function translate(part) {
      part = part.trim();
      var list = [tjWords(part).join('-')];
      if (TJ_COLOUR_WORDS[part]) list = list.concat(TJ_COLOUR_WORDS[part]);
      Object.keys(TJ_COLOUR_PREFIX).forEach(function (pre) {
        var rest = part.indexOf(pre) === 0 ? part.slice(pre.length).trim() : '';
        if (rest && TJ_COLOUR_WORDS[rest]) {
          TJ_COLOUR_WORDS[rest].forEach(function (w) { list.push(TJ_COLOUR_PREFIX[pre] + '-' + w); list.push(TJ_COLOUR_PREFIX[pre] + w); });
          TJ_COLOUR_WORDS[rest].forEach(function (w) { out.push({ words: tjWords(w), weight: 0.5 }); });
          out.push({ words: tjWords(rest), weight: 0.5 });
        }
      });
      return list;
    }
    if (parts.length === 1) {
      translate(parts[0]).forEach(function (p) { out.push({ words: tjWords(p), weight: 1 }); });
    } else {
      var a = translate(parts[0]);
      var b = translate(parts[1]);
      a.forEach(function (x) {
        b.forEach(function (y) {
          out.push({ words: tjWords(x).concat(tjWords(y)), weight: 1 });
          out.push({ words: tjWords(y).concat(tjWords(x)), weight: 1 });
        });
        out.push({ words: tjWords(x), weight: 0.5 });
      });
      b.forEach(function (y) { out.push({ words: tjWords(y), weight: 0.5 }); });
    }
    return out.filter(function (p) { return p.words.length && p.words.join('').length > 2; });
  }

  function tjPhraseIn(words, phrase) {
    for (var i = 0; i + phrase.length <= words.length; i++) {
      var hit = true;
      for (var j = 0; j < phrase.length; j++) {
        if (words[i + j] !== phrase[j]) { hit = false; break; }
      }
      if (hit) return true;
    }
    return false;
  }

  /* input: { colours: [value], media: [{ id, file, alt }], featured: { value: mediaId },
     map: { foldedValue: [token] }, stop: [word], lead: bool }
     output: { grouped: bool, of: { mediaId: value }, by: { mediaId: 'link'|'file'|'alt'|'between' } } */
  function tjGroupMedia(input) {
    var colours = input.colours || [];
    var media = input.media || [];
    var featured = input.featured || {};
    var result = { grouped: false, of: {}, by: {} };
    if (colours.length < 2 || media.length < 2) return result;

    var stop = {};
    TJ_COLOUR_STOP.concat(input.stop || []).forEach(function (w) { tjWords(w).forEach(function (x) { stop[x] = true; }); });

    var phrases = {};
    colours.forEach(function (c) {
      phrases[c] = tjColourPhrases(c);
      var mapped = (input.map || {})[tjFold(c)] || (input.map || {})[String(c).toLowerCase()];
      (mapped || []).forEach(function (t) { phrases[c].push({ words: tjWords(t), weight: 1 }); });
    });

    /* words only this colour's featured filename carries */
    var byId = {};
    media.forEach(function (m) { byId[String(m.id)] = m; });
    var featWords = {};
    colours.forEach(function (c) {
      var m = featured[c] != null ? byId[String(featured[c])] : null;
      featWords[c] = m ? tjWords(String(m.file).replace(/\.[a-z0-9]+$/i, '')) : [];
    });
    function candidate(w) {
      return !stop[w] && !/^\d+$/.test(w) && w.length > 2 && !/^v\d*$/.test(w);
    }
    /* only when two colours have a featured filename with words of its own;
       one supplier named file among store named ones would make the
       supplier's generic words look like a colour */
    var named = colours.filter(function (c) { return featWords[c].some(candidate); }).length;
    colours.forEach(function (c) {
      var own = featWords[c];
      if (named < 2 || !own.length) return;
      var keep = own.map(function (w) {
        if (!candidate(w)) return false;
        for (var k = 0; k < colours.length; k++) {
          if (colours[k] !== c && featWords[colours[k]].indexOf(w) !== -1) return false;
        }
        return true;
      });
      var run = [];
      for (var i = 0; i <= own.length; i++) {
        if (i < own.length && keep[i]) { run.push(own[i]); continue; }
        if (run.length && run.length <= 3) phrases[c].push({ words: run.slice(), weight: 1 });
        run = [];
      }
    });

    function best(words) {
      var top = 0;
      var who = null;
      var tie = false;
      colours.forEach(function (c) {
        var score = 0;
        phrases[c].forEach(function (p) {
          if (p.weight * p.words.length > score && tjPhraseIn(words, p.words)) score = p.weight * p.words.length;
        });
        if (score > top) { top = score; who = c; tie = false; } else if (score > 0 && score === top) { tie = true; }
      });
      return tie ? null : who;
    }

    var alts = {};
    media.forEach(function (m) { alts[String(m.alt || '')] = true; });
    var altsDiffer = Object.keys(alts).length > 1;

    var wordColours = {};
    media.forEach(function (m) {
      var id = String(m.id);
      var c = best(tjWords(String(m.file).replace(/\.[a-z0-9]+$/i, '')));
      var how = 'file';
      if (!c && altsDiffer && m.alt) { c = best(tjWords(m.alt)); how = 'alt'; }
      if (c) { result.of[id] = c; result.by[id] = how; wordColours[c] = true; }
    });
    result.grouped = Object.keys(wordColours).length >= 2;

    colours.forEach(function (c) {
      if (featured[c] != null && byId[String(featured[c])]) {
        result.of[String(featured[c])] = c;
        result.by[String(featured[c])] = 'link';
      }
    });

    if (result.grouped) {
      /* `lead`: the first photo is the selected variant's, printed ahead of
         product order by the theme, so it takes no part in the neighbours */
      media = input.lead ? media.slice(1) : media;
      var i = 0;
      while (i < media.length) {
        if (result.of[String(media[i].id)]) { i++; continue; }
        var j = i;
        while (j < media.length && !result.of[String(media[j].id)]) j++;
        var before = i > 0 ? result.of[String(media[i - 1].id)] : null;
        var after = j < media.length ? result.of[String(media[j].id)] : null;
        if (before && before === after && j - i <= 2) {
          for (var k = i; k < j; k++) { result.of[String(media[k].id)] = before; result.by[String(media[k].id)] = 'between'; }
        }
        i = j;
      }
    }
    return result;
  }
  /* tj-colour-groups:end */
  function mediaIdOf(item) {
    return String(item.getAttribute('data-media-id') || '').split('-').pop();
  }

  function mediaFileOf(item) {
    var img = item.querySelector('img');
    var src = img ? (img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc || '') : '';
    if (!src) {
      var source = item.querySelector('source[srcset]');
      src = source ? String(source.getAttribute('srcset')).split(/[\s,]/)[0] : '';
    }
    return src.split('?')[0].split('/').pop();
  }

  /* The grouping is worked out once per gallery: the media and the variants
     do not change while the page is open, only which colour is chosen. */
  var colourGroups = null;

  function colourGroupsFor(items) {
    var key = items.map(mediaIdOf).sort().join(',');
    if (colourGroups && colourGroups.key === key) return colourGroups;
    var variants = variantsJson() || [];
    var colour = selectedColour();
    var opt = '';
    ['option1', 'option2', 'option3'].forEach(function (o) {
      if (opt || !colour) return;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i][o] || '').trim().toLowerCase() === colour) { opt = o; return; }
      }
    });
    var colours = [];
    var featured = {};
    if (opt) {
      variants.forEach(function (v) {
        var value = String(v[opt] || '').trim();
        if (!value) return;
        if (colours.indexOf(value) === -1) colours.push(value);
        if (featured[value] == null && v.featured_media) featured[value] = String(v.featured_media.id);
      });
    }
    /* sizes are never colours */
    if (colours.length && colours.every(function (c) { return /^\d/.test(c); })) colours = [];
    var title = $('h1');
    var media = items.map(function (item) {
      var img = item.querySelector('img');
      return { id: mediaIdOf(item), file: mediaFileOf(item), alt: item.getAttribute('data-alt') || (img ? img.getAttribute('alt') : '') || '' };
    });
    colourGroups = {
      key: key,
      result: tjGroupMedia({
        colours: colours,
        media: media,
        featured: featured,
        /* display_variant_image_first prints the selected variant's photo
           first, out of product order */
        lead: media.length > 0 && Object.keys(featured).some(function (c) { return featured[c] === media[0].id; }),
        map: colourMap() || {},
        stop: [decodeURIComponent((window.location.pathname.split('/products/')[1] || '').split('/')[0]), title ? title.textContent : '']
      })
    };
    return colourGroups;
  }

  /* The pass is written as "work out the whole answer, then change only what
     differs". A remove followed by an add would be two mutation records every
     time, and the observer that calls this function would never settle. */
  function wantHidden(items) {
    var groups = colourGroupsFor(items).result;
    if (!groups.grouped) return [];
    var colour = selectedColour();
    var chosen = null;
    Object.keys(groups.of).forEach(function (id) {
      if (!chosen && String(groups.of[id]).toLowerCase() === colour) chosen = groups.of[id];
    });
    /* nothing is known about the chosen colour: hide nothing */
    if (!chosen) return [];
    return items.filter(function (item) {
      var owner = groups.of[mediaIdOf(item)];
      return !!owner && owner !== chosen;
    });
  }

  function applyColourFilter() {
    var items = $$('media-gallery .product__media-item');
    if (!items.length) return;
    var off = wantHidden(items);
    var offIds = off.map(mediaIdOf);
    var changed = false;

    items.forEach(function (item) {
      var marked = item.getAttribute('data-tj-colour') === 'off';
      var shouldHide = off.indexOf(item) !== -1;

      if (shouldHide) {
        if (!marked) item.setAttribute('data-tj-colour', 'off');
        /* the theme re shows every slide on a variant change, so the class is
           re applied whenever it has gone missing, and only then */
        if (!item.classList.contains('hidden')) { item.classList.add('hidden'); changed = true; }
      } else if (marked) {
        item.removeAttribute('data-tj-colour');
        if (item.classList.contains('hidden')) { item.classList.remove('hidden'); changed = true; }
      }
    });

    /* thumbnails follow their photo */
    $$('media-gallery [id^="GalleryThumbnails"] [data-target]').forEach(function (thumb) {
      var hide = offIds.indexOf(String(thumb.getAttribute('data-target') || '').split('-').pop()) !== -1;
      var marked = thumb.getAttribute('data-tj-colour') === 'off';
      if (hide) {
        if (!marked) thumb.setAttribute('data-tj-colour', 'off');
        if (!thumb.classList.contains('hidden')) thumb.classList.add('hidden');
      } else if (marked) {
        thumb.removeAttribute('data-tj-colour');
        if (thumb.classList.contains('hidden')) thumb.classList.remove('hidden');
      }
    });

    /* the phone slider counts its pages again, so "1 / 8" matches the set */
    if (changed) {
      $$('media-gallery [id^="GalleryViewer"]').forEach(function (viewer) {
        try {
          if (viewer.initPages) viewer.initPages();
          if (viewer.update) viewer.update();
        } catch (e) { /* the counter is cosmetic */ }
      });
    }
  }

  /* ---------- the desktop grid: two rounds of wide, tall, tall ----------------- */
  /* The cell pattern cannot come from `:nth-child()` once media are filtered
     out, because a hidden sibling still counts. JS writes the span on the
     visible cells only, and the CSS pattern stays as the no script fallback.
     Above 990px the grid stops at six cells and a button reveals the rest; the
     phone rail is untouched and keeps every photograph on one swipe. */

  var GALLERY_CAP = 6;
  var galleryExpanded = false;

  function layoutGalleryGrid() {
    $$('media-gallery .product__media-list').forEach(function (list) {
      var items = $$('.product__media-item', list);
      var shown = items.filter(function (item) {
        return !item.classList.contains('hidden');
      });

      items.forEach(function (item) {
        item.removeAttribute('data-tj-cell');
        item.removeAttribute('data-tj-more');
      });

      var last = Math.min(shown.length, galleryExpanded ? shown.length : GALLERY_CAP) - 1;

      shown.forEach(function (item, index) {
        /* one or two photographs get a cell each rather than a half column,
           which would crop a packshot down the middle */
        var wide = shown.length < 3 || index % 3 === 0;
        /* a colour filter can leave a count that does not divide by three, and
           the leftover tall cell would sit alone in a half empty row. It takes
           the whole row instead. */
        if (!wide && index === last && index % 3 === 1) wide = true;
        item.setAttribute('data-tj-cell', wide ? 'wide' : 'tall');
        if (!galleryExpanded && index >= GALLERY_CAP) item.setAttribute('data-tj-more', 'hidden');
      });

      updateGalleryMore(list, galleryExpanded ? 0 : Math.max(0, shown.length - GALLERY_CAP));
    });
  }

  function updateGalleryMore(list, rest) {
    var host = list.parentNode;
    if (!host) return;
    var button = host.querySelector('[data-tj-gallery-more]');

    if (rest < 1) {
      if (button) button.parentNode.removeChild(button);
      return;
    }

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'tj-gallery-more';
      button.setAttribute('data-tj-gallery-more', '');
      button.addEventListener('click', function () {
        galleryExpanded = true;
        syncGalleryRail();
        track('tj_gallery_expanded', {});
        var first = $$('.product__media-item:not(.hidden)', list)[GALLERY_CAP];
        if (first) {
          var focusable = first.querySelector('a, button, img');
          if (focusable && focusable.focus) focusable.focus({ preventScroll: true });
        }
      });
      host.insertBefore(button, list.nextSibling);
    }

    var label = fill(LABELS.galleryMore || 'Visa fler bilder ({count})', { count: rest });
    if (button.textContent !== label) button.textContent = label;
  }

  function applyGalleryRail() {
    $$('media-gallery .product__media-list').forEach(function (list) {
      var cells = $$('.product__media-item:not(.hidden) .product-media-container', list);
      var pairs = [];
      cells.forEach(function (container) {
        var ratio = mediaRatio(container);
        if (!isNaN(ratio) && ratio > 0) pairs.push({ container: container, ratio: ratio });
      });
      if (!pairs.length) return;

      var rail = Math.min(RAIL_MAX, Math.max(RAIL_MIN, pairs[0].ratio));

      list.style.setProperty('--tj-rail-ratio', String(rail));
      pairs.forEach(function (pair) {
        var off = Math.abs(pair.ratio - rail) / rail;
        pair.container.classList.toggle('tj-media--contain', off > RAIL_TOLERANCE);
      });
    });
  }

  var galleryObservers = [];

  function watchGallery() {
    syncGalleryRail();
    if (!window.MutationObserver) return;
    $$('media-gallery').forEach(function (gallery) {
      if (gallery.getAttribute('data-tj-watched') === 'true') return;
      gallery.setAttribute('data-tj-watched', 'true');
      var pending;
      var observer = new MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(syncGalleryRail, 120);
      });
      /* Shrine re filters and re orders the slides on every variant change,
         which changes which photo is first and so what shape the rail takes */
      observer.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      galleryObservers.push(observer);
    });
  }

  /* ---------- an app section with nothing in it --------------------------------- */
  /* The Vitals product reviews app renders a full height widget even when the
     product has no reviews, so on Allure a 0 rating and "Inga recensioner än"
     sit directly under the 4,4 store rating and read as a contradiction. The
     section is hidden only while its own rendered text says it is empty, so
     the first real review brings it straight back. */

  var EMPTY_REVIEW_TEXT = /inga recensioner|0\s*recensioner|no reviews yet/i;

  function hideEmptyReviewApps() {
    $$('[id^="shopify-section"]').forEach(function (section) {
      /* never the main product section, and never one of ours */
      if (/-main$|__main$/.test(section.id)) return;
      if (section.querySelector('.tj-pdp')) return;
      /* the store reviews band carries the product reviews itself (patch 3h)
         and Liquid already leaves them out when there are none */
      if (section.querySelector('.trustpilot-reviews')) return;
      var text = (section.innerText || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      var empty = EMPTY_REVIEW_TEXT.test(text) && !/[1-9]\d*\s*(recension|review)/i.test(text);
      if (empty) {
        if (section.getAttribute('data-tj-empty-reviews') !== 'true') {
          section.setAttribute('data-tj-empty-reviews', 'true');
        }
      } else if (section.getAttribute('data-tj-empty-reviews') === 'true') {
        section.removeAttribute('data-tj-empty-reviews');
      }
    });
  }

  /* ---------- the store rating's scroll target ---------------------------------- */
  /* The Trustpilot stars block links to `#shopify-section-tj_reviews`, but a
     section that lives in a JSON template is rendered with the template id in
     front of its name, so that anchor does not exist on the page and the link
     does nothing. The real section is given the short id as well. */

  function aliasReviewsSection() {
    if (document.getElementById('shopify-section-tj_reviews')) return;
    var real = $$('[id^="shopify-section"]').filter(function (section) {
      return /__tj_reviews$/.test(section.id);
    })[0];
    if (!real) return;
    var anchor = document.createElement('span');
    anchor.id = 'shopify-section-tj_reviews';
    anchor.className = 'tj-anchor';
    real.parentNode.insertBefore(anchor, real);
  }

  /* ---------- in page links ---------------------------------------------------- */
  /* Every in page jump goes through one function, so the sticky header offset
     is applied once. `scrollIntoView({block:'start'})` puts the target's top
     at the viewport top, which on this store is behind the header. */

  function headerOffset() {
    var header = $('.section-header, sticky-header, .header-wrapper, #shopify-section-header') ||
      $('[id*="__header"]');
    var height = 0;
    if (header) {
      var box = header.getBoundingClientRect();
      if (box.height > 0 && box.height < 260) height = box.height;
    }
    return height + 16;
  }

  function scrollToElement(target, behavior) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || (REDUCE ? 'auto' : 'smooth') });
  }

  /* A variant change makes Shrine re render the buy column and re filter the
     gallery, and its own `setActiveMedia` scrolls to the new first photograph.
     That lands the shopper at the top of the gallery, several screens above
     the chip they were just given, which is the bug this replaces. So the
     scroll is asserted once, then checked again once the page has settled and
     corrected without animation if something moved underneath it. */
  function scrollToElementSettled(target) {
    if (!target) return;
    scrollToElement(target);
    if (REDUCE) return;
    window.setTimeout(function () {
      var wanted = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      if (Math.abs(wanted - window.pageYOffset) > 40) {
        window.scrollTo({ top: Math.max(0, wanted), behavior: 'auto' });
      }
    }, 700);
  }

  function bindScrollLink(link) {
    if (link.getAttribute('data-tj-scroll-bound') === 'true') return;
    link.setAttribute('data-tj-scroll-bound', 'true');
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      scrollToElement(target);
      var field = target.querySelector('input[type="text"], input[inputmode="decimal"]');
      if (field) {
        window.setTimeout(
          function () {
            field.focus({ preventScroll: true });
          },
          REDUCE ? 0 : 420
        );
      }
    });
  }

  function initScrollLinks() {
    $$('a[data-tj-scroll]').forEach(bindScrollLink);
  }

  /* ---------- colour swatches: whole shoe in the thumbnail, a click commits -- */
  /* Variant Swatch King asks the CDN for every swatch thumbnail with
     `height=..&crop=top`. The packshots are 1350 x 1800 portraits with the
     shoe in the lower middle, so the square it gets back is the empty top of
     the photograph and a sliver of shoe. The thumbnail is asked for again
     uncropped and `tj-pdp.css` shows it with `contain` on the mist ground. */

  function fixSwatchThumbs() {
    $$('variant-swatch-king .star-set-image').forEach(function (node) {
      var bg = node.style.backgroundImage;
      if (!bg || bg.indexOf('crop=') === -1) return;
      node.style.backgroundImage = bg
        .replace(/&(amp;)?height=\d+/g, '')
        .replace(/&(amp;)?crop=[a-z_]+/g, '')
        .replace(/([?&])width=\d+/, '$1width=240');
      node.classList.add('tj-thumb');
    });
  }

  function watchSwatchThumbs() {
    fixSwatchThumbs();
    if (!window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        fixSwatchThumbs();
      });
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  /* ---------- size rows: even grid for numbers, fitted chips for words ------ */
  /* The size row is an even 6 (4 on a phone) column grid, which suits "42"
     and "36-37". A label such as "Medium 38-41" does not fit a phone cell, so
     each row is measured: every label on one line against its chip's text
     room. The selected check is left out of the sum on purpose: counted, it
     tips plain numbers into chips on a tablet, where the buy column is narrow
     and a selected "36" already shares its cell with the check. When any
     label does not fit, the row gets `tj-sizes--fluid` and `tj-pdp.css` turns it
     into wrapping chips sized to their text. The measure is synchronous
     (attribute on, read, attribute off) so no frame shows the measuring
     state, and it runs from a MutationObserver callback, which lands before
     the next paint, so a fresh render from the app never paints clipped.
     Covers Variant Swatch King's size rows and Shrine's own pill groups. */

  var FLUID = 'tj-sizes--fluid';

  function sizeRows() {
    var rows = [];
    $$('variant-swatch-king [option-name]').forEach(function (group) {
      if (!/storlek|size/i.test(group.getAttribute('option-name') || '')) return;
      $$('ul.swatch-view.swatch-view-button', group).forEach(function (ul) {
        rows.push({ row: ul, chips: $$('.swatch-button', ul) });
      });
    });
    $$('.product-form__input.product-form__input--pills').forEach(function (group) {
      if (group.classList.contains('product-form__input--quantity-breaks')) return;
      rows.push({ row: group, chips: $$('input[type="radio"] + label', group) });
    });
    return rows;
  }

  /* the width of the visible text on one line; Shrine's labels also carry a
     visually hidden "sold out" note, which does not count */
  function labelWidth(chip) {
    var walker = document.createTreeWalker(chip, NodeFilter.SHOW_TEXT, null);
    var range = document.createRange();
    var width = 0;
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue.trim()) continue;
      if (node.parentNode && closest(node.parentNode, '.visually-hidden')) continue;
      range.selectNodeContents(node);
      width += range.getBoundingClientRect().width;
    }
    return width;
  }

  function fitSizeRow(entry) {
    var row = entry.row;
    var wasFluid = row.classList.contains(FLUID);
    var measured = false;
    var tooWide = false;

    if (wasFluid) row.classList.remove(FLUID);
    row.setAttribute('data-tj-sizes', 'measure');
    entry.chips.forEach(function (chip) {
      if (tooWide || !chip.getClientRects().length) return;
      var cs = window.getComputedStyle(chip);
      var room = chip.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
      if (room <= 0) return;
      measured = true;
      if (labelWidth(chip) > room + 0.5) tooWide = true;
    });
    row.removeAttribute('data-tj-sizes');

    /* a hidden row (a collapsed tab, a closed modal) keeps its last answer */
    var fluid = measured ? tooWide : wasFluid;
    if (fluid) row.classList.add(FLUID);
    return fluid !== wasFluid;
  }

  function fitSizeRows() {
    var changed = false;
    sizeRows().forEach(function (entry) {
      if (fitSizeRow(entry)) changed = true;
    });
    /* our own class writes must not wake the size gate observer */
    if (pickerObserver) pickerObserver.takeRecords();
    return changed;
  }

  function inPicker(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentNode;
    return !!(el && closest(el, 'variant-swatch-king, variant-selects, .product-form__input--pills'));
  }

  function watchSizeRows() {
    fitSizeRows();

    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          var hit = inPicker(r.target);
          for (var j = 0; !hit && j < r.addedNodes.length; j++) {
            var n = r.addedNodes[j];
            hit = n.nodeType === 1 && (inPicker(n) || !!(n.querySelector && n.querySelector('variant-swatch-king, variant-selects')));
          }
          if (hit) {
            fitSizeRows();
            return;
          }
        }
      }).observe(document.body, { subtree: true, childList: true, characterData: true });
    }

    var queued = false;
    window.addEventListener('resize', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        fitSizeRows();
      });
    });

    /* the label width changes when the brand font arrives */
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(fitSizeRows);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitSizeRows);
    }
  }

  /* On product cards the app runs with `switch_on_hover`: hovering a colour
     previews its photo, and leaving puts back the card's current variant. Its
     click path never updates that current variant on this theme, so a click
     looked like nothing: the photo snapped back on mouse out and the card link
     still opened the first colour. A click here resolves the variant from the
     product's own JSON and commits it: photo, `swatch-current-variant` and the
     variant on every link in the card. The app's own hover preview still
     works on top of the committed colour. */

  var productJsonCache = {};

  function productJson(handle) {
    if (!productJsonCache[handle]) {
      productJsonCache[handle] = window
        .fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    }
    return productJsonCache[handle];
  }

  function mediaPath(src) {
    return String(src || '').split('?')[0].split('/').pop();
  }

  function applyCardCommit(card) {
    var c = card.__tjCommit;
    if (!c) return;
    $$('.card__media img', card).forEach(function (img, i) {
      var src = c.pair[i] || c.pair[0];
      if (!src) return;
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
    });
    card.setAttribute('swatch-current-variant', String(c.id));
    $$('a[href*="/products/"]', card).forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        u.searchParams.set('variant', String(c.id));
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    });
  }

  function commitCardSwatch(card, li) {
    var list = closest(li, 'ul[data-product-handle]');
    var group = closest(li, '[option-target]');
    var value = li.getAttribute('orig-value');
    if (!list || !group || !value) return;
    var index = parseInt(String(group.getAttribute('option-target')).replace('option', ''), 10) - 1;
    /* what the hover preview is showing right now, before the app reverts */
    var shown = $$('.card__media img', card).map(function (img) {
      return img.getAttribute('src');
    });
    productJson(list.getAttribute('data-product-handle')).then(function (p) {
      if (!p || !p.variants) return;
      var matches = p.variants.filter(function (v) {
        return v.options && v.options[index] === value;
      });
      if (!matches.length) return;
      var v = matches.filter(function (m) { return m.available; })[0] || matches[0];
      var featured = v.featured_image && v.featured_image.src;
      var pair = shown;
      if (featured && mediaPath(shown[0]) !== mediaPath(featured)) {
        var url = featured.indexOf('//') === 0 ? 'https:' + featured : featured;
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=720';
        pair = [url, url];
      }
      card.__tjCommit = { id: v.id, pair: pair };
      applyCardCommit(card);
      guardCardCommit(card);
    });
  }

  function initCardSwatches() {
    function handle(e) {
      var li = closest(e.target, 'variant-swatch-king li.swatch-view-item');
      var card = li && closest(li, '.card-wrapper');
      if (card) commitCardSwatch(card, li);
    }
    /* capture phase: the app stops the click from bubbling. Nothing here
       cancels it, so the size gate's own capture guard is unaffected. */
    document.addEventListener('click', handle, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') handle(e);
    }, true);
    /* The app restores the old variant some time after the pointer leaves
       the swatches. A committed card therefore watches its own images and
       puts the committed colour back whenever they change outside a hover
       preview of another swatch. */
    document.addEventListener('mouseover', function (e) {
      var li = closest(e.target, 'variant-swatch-king li.swatch-view-item');
      var card = li && closest(li, '.card-wrapper');
      if (card) card.__tjPreview = true;
    }, true);
    document.addEventListener('mouseout', function (e) {
      var card = closest(e.target, '.card-wrapper');
      if (!card) return;
      var to = e.relatedTarget;
      if (to && card.contains(to) && closest(to, 'variant-swatch-king li')) return;
      card.__tjPreview = false;
      if (card.__tjCommit) window.setTimeout(function () { applyCardCommit(card); }, 0);
    }, true);
  }

  function guardCardCommit(card) {
    if (card.__tjGuard || !window.MutationObserver) return;
    card.__tjGuard = new MutationObserver(function () {
      if (card.__tjPreview || !card.__tjCommit) return;
      var first = $('.card__media img', card);
      if (first && first.getAttribute('src') !== (card.__tjCommit.pair[0])) applyCardCommit(card);
    });
    $$('.card__media img', card).forEach(function (img) {
      card.__tjGuard.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
    });
  }

  /* ---------- packshots sit whole on the mist ground -------------------------- */
  /* The gallery cells have fixed shapes (3:2 wide, 4:5 tall) and the theme
     fits every photo with cover. A lifestyle photo survives that; a studio
     packshot does not, because the part that gets cut is the shoe. A photo is
     a packshot when the edge of a 24px copy of it is near white. That copy is
     fetched with CORS (the Shopify CDN allows it) so the canvas can be read.
     Packshots get `tj-media--packshot`, and `tj-pdp.css` shows them whole with
     `contain`, the white field blended into the mist. */

  function isWhiteEdge(img) {
    try {
      var w = img.naturalWidth;
      var h = img.naturalHeight;
      if (!w || !h) return false;
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      var data = ctx.getImageData(0, 0, w, h).data;
      var total = 0;
      var white = 0;
      function test(x, y) {
        var i = (y * w + x) * 4;
        total += 1;
        if (data[i + 3] < 16 || (data[i] > 232 && data[i + 1] > 232 && data[i + 2] > 232)) white += 1;
      }
      for (var x = 0; x < w; x++) test(x, 0);
      for (var y = 0; y < h; y++) {
        test(0, y);
        test(w - 1, y);
      }
      return white / total > 0.9;
    } catch (e) {
      return false;
    }
  }

  function markPackshots() {
    $$('media-gallery .product__media-list > .product__media-item').forEach(function (item) {
      if (item.hasAttribute('data-tj-shot')) return;
      var img = $('.media > img', item) || $('img', item);
      var src = img && (img.getAttribute('src') || img.currentSrc);
      if (!src) return;
      item.setAttribute('data-tj-shot', 'pending');
      var url = src.indexOf('//') === 0 ? 'https:' + src : src;
      url = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=24';
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var shot = isWhiteEdge(probe) ? 'packshot' : 'photo';
        item.setAttribute('data-tj-shot', shot);
        item.classList.toggle('tj-media--packshot', shot === 'packshot');
      };
      probe.onerror = function () {
        item.setAttribute('data-tj-shot', 'unknown');
      };
      probe.src = url;
    });
  }

  /* ---------- one step between sections on the same ground -------------------- */
  /* `tj-pdp.css` gives every section the same top and bottom step. Where two
     neighbours share a ground (white on white, stone on stone) that would be
     two steps of the same colour, so the lower one drops its top padding.
     The ground is the first solid background found on the section or on the
     element that fills it; a photograph or gradient never joins. */

  function sectionGround(section) {
    var nodes = [section];
    var node = section;
    for (var depth = 0; depth < 3 && node; depth++) {
      node = node.firstElementChild;
      while (node && (node.tagName === 'STYLE' || node.tagName === 'SCRIPT' || node.tagName === 'LINK')) {
        node = node.nextElementSibling;
      }
      if (node) nodes.push(node);
    }
    var sr = section.getBoundingClientRect();
    for (var i = 0; i < nodes.length; i++) {
      var cs = getComputedStyle(nodes[i]);
      var r = nodes[i].getBoundingClientRect();
      var fills = r.height >= sr.height * 0.9;
      if (!fills) continue;
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return 'image';
      if (nodes[i].classList && nodes[i].classList.contains('tj-brand--band')) return 'image';
      var bg = cs.backgroundColor;
      if (bg && bg !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(bg)) {
        return bg.replace(/\s+/g, '') === 'rgb(255,255,255)' ? 'white' : bg.replace(/\s+/g, '');
      }
    }
    return 'white';
  }

  function joinSections() {
    var prev = null;
    $$('main > .shopify-section').forEach(function (section) {
      var r = section.getBoundingClientRect();
      if (r.height < 2) return;
      var ground = sectionGround(section);
      var join = prev !== null && ground !== 'image' && ground === prev;
      if (join) section.setAttribute('data-tj-join', '');
      else section.removeAttribute('data-tj-join');
      prev = ground;
    });
  }

  /* ---------- start ------------------------------------------------------------ */

  function start() {
    /* the blocks that print their own totals share this formatter, so a page
       never mixes two money formats */
    CFG.formatMoney = money;

    track('tj_template_variant', { tj_price_varies: !!CFG.priceVaries });

    /* a deep link with ?variant= is a real choice, not Shrine's preselection */
    try {
      if (new URL(window.location.href).searchParams.has('variant')) state.sizeChosen = true;
    } catch (e) {
      state.sizeChosen = /[?&]variant=/.test(window.location.search);
    }

    syncBuyColumn();
    watchPickers();
    initPromo();
    placeSizeHelp();
    $$('[data-tj-finder]').forEach(initFinder);
    watchAddons();
    updateMeter();
    initLeaders();
    initScrollLinks();
    watchGallery();
    aliasReviewsSection();
    hideEmptyReviewApps();
    watchSwatchThumbs();
    watchSizeRows();
    initCardSwatches();
    markPackshots();
    joinSections();

    /* A picker app embed renders after the theme does, sometimes seconds
       later, so the gate and the observer are re armed a few times while the
       page settles. Each pass is a no op once a size has been chosen. */
    [250, 800, 2000, 4000].forEach(function (delay) {
      window.setTimeout(function () {
        watchPickers();
        syncBuyColumn();
        placePromo();
        placeSizeHelp();
        syncGalleryRail();
        hideEmptyReviewApps();
        markPackshots();
        joinSections();
        fitSizeRows();
      }, delay);
    });

    subscribeTo('variantChange', 'variant-change', function () {
      queueSync();
    });
    subscribeTo('cartUpdate', 'cart-update', function () {
      refreshCartTotal();
    });
    document.addEventListener('cart:updated', refreshCartTotal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
